import { TranslationKey, translationKey } from 'intl/types/translationKey';

/**
 * AUTO-GENERATED — do not edit manually.
 * Run `yarn generate:translation-keys` after changing messages.en.json.
 */
export const CommonTranslationKeys = {
  autocompleteNoOptions: translationKey('autocomplete_no_options'),
  bottomNavCreate: translationKey('bottom_nav_create'),
  buttonCreateCompany: translationKey('button_create_company'),
  buttonCreateContract: translationKey('button_create_contract'),
  buttonCreateInspection: translationKey('button_create_inspection'),
  buttonCreateInspectionTemplate: translationKey('button_create_inspection_template'),
  buttonCreateUser: translationKey('button_create_user'),
  buttonShowChangelog: translationKey('button_show_changelog'),
  buttonTooltipOpenFileInDocumentation: translationKey('button_tooltip_open_file_in_documentation'),
  confirmAbort: translationKey('confirm_abort'),
  dataGridActionsSelectedCount: translationKey('dataGrid_actions_selected_count'),
  dataGridManageColumns: translationKey('dataGrid_manage_columns'),
  disabledCannotAddMoreTranslations: translationKey('disabled_cannot_add_more_translations'),
  disabledCannotAddTranslationMustBeFilled: translationKey('disabled_cannot_add_translation_must_be_filled'),
  disabledCannotChangeHustroDefault: translationKey('disabled_cannot_change_hustro_default'),
  disabledCannotChangeLanguageAfterAddNext: translationKey('disabled_cannot_change_language_after_add_next'),
  disabledCannotChangeSavedTranslation: translationKey('disabled_cannot_change_saved_translation'),
  disabledCannotRemoveSavedTranslation: translationKey('disabled_cannot_remove_saved_translation'),
  disabledNothingToSave: translationKey('disabled_nothing_to_save'),
  disabledRequireAtLeastOneFieldOption: translationKey('disabled_require_at_least_one_field_option'),
  disabledSaveInProgress: translationKey('disabled_save_in_progress'),
  downloadClickButtonPrompt: translationKey('download_click_button_prompt'),
  downloadingInfo: translationKey('downloading_info'),
  downloadingInfoWebMobile: translationKey('downloading_info_web_mobile'),
  editDocumentation: translationKey('edit_documentation'),
  free: translationKey('free'),
  from: translationKey('from'),
  add: translationKey('general_add'),
  addFiles: translationKey('general_add_files'),
  apply: translationKey('general_apply'),
  archive: translationKey('general_archive'),
  archived: translationKey('general_archived'),
  back: translationKey('general_back'),
  cancel: translationKey('general_cancel'),
  change: translationKey('general_change'),
  chooseFromDevice: translationKey('general_choose_from_device'),
  chooseFromDocumentation: translationKey('general_choose_from_documentation'),
  clear: translationKey('general_clear'),
  delete: translationKey('general_delete'),
  description: translationKey('general_description'),
  discard: translationKey('general_discard'),
  documentation: translationKey('general_documentation'),
  download: translationKey('general_download'),
  dragging: translationKey('general_dragging'),
  edit: translationKey('general_edit'),
  export: translationKey('general_export'),
  exportToDocumentation: translationKey('general_export_to_documentation'),
  exportToDocumentationNotAllowed: translationKey('general_export_to_documentation_not_allowed'),
  fieldsSettings: translationKey('general_fields_settings'),
  import: translationKey('general_import'),
  lastModificationDate: translationKey('general_last_modification_date'),
  level: translationKey('general_level'),
  logOut: translationKey('general_log_out'),
  modifiedAtRelatedTime: translationKey('general_modified_at_related_time'),
  modifiedAtRelatedTimeJustNow: translationKey('general_modified_at_related_time_just_now'),
  modifiedAtRelatedTimeWithUser: translationKey('general_modified_at_related_time_with_user'),
  modifiedAtRelatedTimeWithUserJustNow: translationKey('general_modified_at_related_time_with_user_just_now'),
  moreOptions: translationKey('general_more_options'),
  move: translationKey('general_move'),
  no: translationKey('general_no'),
  noData: translationKey('general_no_data'),
  noMapAvailable: translationKey('general_no_map_available'),
  none: translationKey('general_none'),
  notFilled: translationKey('general_not_filled'),
  offlineOperationUnavailable: translationKey('general_offline_operation_unavailable'),
  ok: translationKey('general_ok'),
  operationUnavailable: translationKey('general_operation_unavailable'),
  or: translationKey('general_or'),
  process: translationKey('general_process'),
  project: translationKey('general_project'),
  publish: translationKey('general_publish'),
  remove: translationKey('general_remove'),
  reset: translationKey('general_reset'),
  restore: translationKey('general_restore'),
  save: translationKey('general_save'),
  saveAsDraft: translationKey('general_save_as_draft'),
  select: translationKey('general_select'),
  send: translationKey('general_send'),
  site: translationKey('general_site'),
  sites: translationKey('general_sites'),
  stageConsultation: translationKey('general_stage_consultation'),
  stageDraft: translationKey('general_stage_draft'),
  stageExecution: translationKey('general_stage_execution'),
  stageLabel: translationKey('general_stage_label'),
  stageResolved: translationKey('general_stage_resolved'),
  unlink: translationKey('general_unlink'),
  untitled: translationKey('general_untitled'),
  update: translationKey('general_update'),
  userDeleted: translationKey('general_user_deleted'),
  userDeletedLabel: translationKey('general_user_deleted_label'),
  yes: translationKey('general_yes'),
  listSearchEmptySubtitle: translationKey('list_search_empty_subtitle'),
  listSearchEmptyTitle: translationKey('list_search_empty_title'),
  miscChooseLanguage: translationKey('misc_choose_language'),
  navigationDrawerItemAnalytics: translationKey('navigation_drawer_item_analytics'),
  navigationDrawerItemBrowseInspections: translationKey('navigation_drawer_item_browseInspections'),
  navigationDrawerItemCompany: translationKey('navigation_drawer_item_company'),
  navigationDrawerItemContract: translationKey('navigation_drawer_item_contract'),
  navigationDrawerItemInspections: translationKey('navigation_drawer_item_inspections'),
  navigationDrawerItemIssues: translationKey('navigation_drawer_item_issues'),
  navigationDrawerItemStartInspection: translationKey('navigation_drawer_item_startInspection'),
  navigationDrawerItemUsers: translationKey('navigation_drawer_item_users'),
  never: translationKey('never'),
  paid: translationKey('paid'),
  readMore: translationKey('read_more'),
  refresh: translationKey('refresh'),
  required: translationKey('required'),
  serviceWorkerUpdateMessage: translationKey('service_worker_update_message'),
  sortWhileDownloadingUnavailable: translationKey('sort_while_downloading_unavailable'),
  tableHeaderLp: translationKey('table_header_lp'),
  temporaryKeyNavigationTemplates: translationKey('temporary_key_navigation_templates'),
  to: translationKey('to'),
  toolbarTitleCreateIssue: translationKey('toolbar_title_create_issue'),
  toolbarTitleCreateSimilar: translationKey('toolbar_title_create_similar'),
} as const satisfies Record<string, TranslationKey>;
